import Confirm from './Confirm';
import ConfirmButton from './ConfirmButton';
import SaveForm from './SaveForm';

const MuiDialog = {
  Confirm,
  ConfirmButton,
  SaveForm,
};

export default MuiDialog;
